import PropTypes from 'prop-types';
import React from 'react';

import { utagLinkSort } from 'features/tealium';
import { ButtonLink } from 'components/Button';
import { triggerEvent } from 'utilities/dom';

import './SortFilterAppliedFilterClearButton.scss';
import sortFilterGenericEvent from 'features/sort/sortFilterGenericEvent';

const onClearClick = (value, name) => {

	utagLinkSort('Sort-Filter-Menu')({
		eventAction: `Remove-${name}`,
		eventLabel: value
	});
	sortFilterGenericEvent('filter_remove', name, value, true);

};

const SortFilterAppliedFilterClearButton = ({
	attributeName, attributeValue, stepbackLink, children
}) => {

	const buttonLabel = `Remove ${attributeValue} from results`;

	const handleOnClick = (event) => {

		if (window.dynamicSort === true) {

			event.preventDefault();
			const destinationUrl = event.currentTarget.getAttribute('href');
			triggerEvent.call(document, 'dynamicNavigation', { destinationUrl });

		}

	};

	return (
		<span
			className="SortFilterAppliedFilterClearButton__container"
			role="none"
			onClick={() => {

				onClearClick(attributeValue, attributeName);

			}}
			onKeyUp={() => { }}
		>
			<ButtonLink
				href={stepbackLink}
				className="SortFilterAppliedFilterClearButton"
				buttonStyleVariant="tertiary"
				title={buttonLabel}
				label={buttonLabel}
				onClick={handleOnClick}
			>
				{children}
			</ButtonLink>
		</span>
	);

};

SortFilterAppliedFilterClearButton.propTypes = {
	attributeName: PropTypes.string.isRequired,
	attributeValue: PropTypes.string.isRequired,
	stepbackLink: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired
};

export default SortFilterAppliedFilterClearButton;
